import React, { useEffect, useState } from "react";
import { CreateUserModal, UserSchema } from "../../models/UserModel";
import UserClient from "../../api-services/user/user-client";
import HandlingResponse from "../../../common/handling-response/handlingResponse";
import Moment from "moment";
import { DatePickerWithCustomHeader } from "../../../common/custom-date-picker/CustomDatePicker.component";
import { useTranslation } from "react-i18next";
import {
  handleSave,
  serverValidation,
  validateForm,
} from "../../../common/validation/validation";

const CreateOrEditUser = ({
  user,
  setUser,
  edit,
  handleClose,
  handleAddingUser,
}) => {
  const { t } = useTranslation();

  const [disableUsername, setDisableUsername] = useState(false);
  const [errors, setErrors] = useState({});

  var client = new UserClient();

  useEffect(() => {
    user && user?.loginName && setDisableUsername(true);
  }, [user]);

  const createEditUser = async (e) => {
    e.preventDefault();
    const errorsResult = validateForm(user, UserSchema, t);
    setErrors(errorsResult);

    if (!errorsResult) {
      var response;
      if (edit) {
        response = await client.updateUser(user);
      } else {
        response = await client.createUser(user);
      }
      let handledResponse = HandlingResponse(response);
      if (handledResponse.code == 408) {
        var result = serverValidation(handledResponse.data, t);
        setErrors(result);
      } else {
        handleAddingUser(handledResponse);
        handleClose();
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUser((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleInputChangeWithValidation = (e) => {
    const obj = { name: e.target.name, value: e.target.value };
    const result = handleSave(obj, user, errors, UserSchema, t);
    setUser(result.data);
    setErrors(result.errors);
  };

  const handleDatePickerChange = (date, name) => {
    setUser((prevFormData) => ({
      ...prevFormData,
      [name]: date,
    }));
  };

  return (
    <form onSubmit={createEditUser}>
      <div className="row">
        <div className="col-6">
          <label>Име</label>
          <input
            className="form-control"
            type="text"
            value={user?.firstName}
            name="firstName"
            onChange={handleInputChangeWithValidation}
          />
          {errors?.firstName && (
            <div className="text-danger">{errors?.firstName}</div>
          )}
        </div>
        <div className="col-6">
          <label>Презиме</label>
          <input
            className="form-control"
            type="text"
            value={user?.lastName}
            name="lastName"
            onChange={handleInputChangeWithValidation}
          />
          {errors?.lastName && (
            <div className="text-danger">{errors?.lastName}</div>
          )}
        </div>
        <div className="col-6">
          <label>Корисничко име</label>
          <input
            className="form-control"
            type="text"
            value={user?.loginName}
            name="loginName"
            onChange={handleInputChangeWithValidation}
            disabled={edit && disableUsername}
          />
          {errors?.loginName && (
            <div className="text-danger">{errors?.loginName}</div>
          )}
        </div>
        <div className="col-6">
          <label>Шифра</label>
          <input
            className="form-control"
            type="text"
            value={user?.password}
            name="password"
            onChange={handleInputChangeWithValidation}
          />
          {errors?.password && (
            <div className="text-danger">{errors?.password}</div>
          )}
        </div>
        <div className="col-6">
          <label>Имејл</label>
          <input
            className="form-control"
            type="text"
            value={user?.email}
            name="email"
            onChange={handleInputChange}
          />
        </div>
        <div className="col-6">
          <label>Компанија</label>
          <input
            className="form-control"
            type="text"
            value={user?.company}
            name="company"
            onChange={handleInputChange}
          />
        </div>
        <div className="col-6">
          <label>ПИБ/ЈМБГ</label>
          <input
            className="form-control"
            type="text"
            value={user?.pib}
            name="pib"
            onChange={handleInputChange}
          />
        </div>
        <div className="col-6">
          <label>Адреса 1</label>
          <input
            className="form-control"
            type="text"
            value={user?.address1}
            name="address1"
            onChange={handleInputChange}
          />
        </div>
        <div className="col-6">
          <label>Адреса 2</label>
          <input
            className="form-control"
            type="text"
            value={user?.address2}
            name="address2"
            onChange={handleInputChange}
          />
        </div>
        <div className="col-6">
          <label>Град</label>
          <input
            className="form-control"
            type="text"
            value={user?.city}
            name="city"
            onChange={handleInputChange}
          />
        </div>
        <div className="col-6">
          <label>Поштански број</label>
          <input
            className="form-control"
            type="text"
            value={user?.postalCode}
            name="postalCode"
            onChange={handleInputChange}
          />
        </div>
        <div className="col-6">
          <label>Држава</label>
          <input
            className="form-control"
            type="text"
            value={user?.state}
            name="state"
            onChange={handleInputChange}
          />
        </div>
        <div className="col-6">
          <label>Телефон 1</label>
          <input
            className="form-control"
            type="text"
            value={user?.phone1}
            name="phone1"
            onChange={handleInputChange}
          />
        </div>
        <div className="col-6">
          <label>Телефон 2</label>
          <input
            className="form-control"
            type="text"
            value={user?.phone2}
            name="phone2"
            onChange={handleInputChange}
          />
        </div>
        <div className="col-6">
          <label>FAX</label>
          <input
            className="form-control"
            type="text"
            value={user?.fax}
            name="fax"
            onChange={handleInputChange}
          />
        </div>
        <div className="col-6">
          <label>Мобилни телефон</label>
          <input
            className="form-control"
            type="text"
            value={user?.mobile}
            name="mobile"
            onChange={handleInputChange}
          />
        </div>
        <div className="col-6">
          <label>www</label>
          <input
            className="form-control"
            type="text"
            value={user?.www}
            name="www"
            onChange={handleInputChange}
          />
        </div>
        <div className="col-6">
          <label>Сектор</label>
          <input
            className="form-control"
            type="text"
            value={user?.sector}
            name="sector"
            onChange={handleInputChange}
          />
        </div>
        {edit && (
          <>
            <div className="col-6">
              <label>Датум првог пријављивања</label>
              <input
                className="form-control"
                type="text"
                value={
                  user?.firstAccess
                    ? Moment(user?.firstAccess).format("DD.MM.YYYY.")
                    : undefined
                }
                name="firstAccess"
                disabled
              />
            </div>
            <div className="col-6">
              <label>Датум последњег пријављивања</label>
              <input
                className="form-control"
                type="text"
                value={
                  user?.lastAccess
                    ? Moment(user?.lastAccess).format("DD.MM.YYYY.")
                    : undefined
                }
                name="lastAccess"
                disabled
              />
            </div>
          </>
        )}
        <div className="col-6">
          <label>Датум истицања претплате</label>
          <DatePickerWithCustomHeader
            selected={user?.orderAlarm ? new Date(user?.orderAlarm) : null}
            onChange={(orderAlarm) => {
              handleDatePickerChange(orderAlarm, "orderAlarm");
            }}
          />
        </div>
        <div className="row">
          <div className="col-6">
            <label>Напомена за корисника</label>
            <textarea
              className="form-control"
              type="text"
              value={user?.noteContacts}
              name="noteContacts"
              onChange={handleInputChange}
            />
          </div>
          <div className="col-6">
            <label>Напомена о поруџбини</label>
            <textarea
              className="form-control"
              type="text"
              value={user?.noteOrders}
              name="noteOrders"
              onChange={handleInputChange}
            />
          </div>
        </div>
      </div>
      <div className="text-right">
        <button
          type="submit"
          className="btn btn-primary"
          style={{ marginTop: "10px", marginLeft: "5px" }}
        >
          {edit ? "Измени" : "Креирај"}
        </button>
      </div>
    </form>
  );
};

export default CreateOrEditUser;
